export default __webpack_public_path__ + "static/media/cards5.2855f44f.png";